import { render, staticRenderFns } from "./link-goal.vue?vue&type=template&id=6055d48b&scoped=true"
import script from "./link-goal.vue?vue&type=script&lang=js"
export * from "./link-goal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055d48b",
  null
  
)

export default component.exports